import { CALL_API } from 'redux-api-middleware';
import { chain, zipObject } from 'lodash';

import { createRequestTypes } from './utils';
import { buildCalendarUrl } from '../service/oms';
import normalizeSymbol from '../service/normalizesymbol';

export const FETCH_EVENTS = createRequestTypes('@@calendar/FETCH_EVENTS');

const markets = ['OSE', 'OAX', 'MERK'];

function trimPayload(values) {
    const event = values;

    for (const market of markets) {
        const longName = values[`${market}_LONG_NAME`];

        if (longName) {
            event.LONG_NAME = longName;
            event.ITEM_SECTOR = values[`${market}_ITEM_SECTOR`];

            break;
        }
    }

    return event;
}

export const requestCalendarData = symbol => {
    let ticker;
    let market;

    if (symbol) {
        [ticker, market] = symbol.split('.');
    }

    const meta = { symbol: symbol ? normalizeSymbol(symbol) : 'All' };

    return {
        [CALL_API]: {
            endpoint: buildCalendarUrl(ticker),
            method: 'GET',
            types: [
                { type: FETCH_EVENTS.REQUEST, meta },
                {
                    type: FETCH_EVENTS.SUCCESS,
                    payload: (action, state, res) => {
                        const contentType = res.headers.get('Content-Type');
                        if (contentType && ~contentType.indexOf('json')) {
                            return res.json().then(
                                json => {
                                    const events = json.rows.map(({ values }) => (
                                        symbol ? values : trimPayload(values)
                                    ));

                                    return symbol ? events : chain(events)
                                        .groupBy('CALENDAR_EVENT_DATE').toPairs()
                                        .map(pair => zipObject(['day', 'events'], pair)).value();
                                }
                            );
                        }
                        return null;
                    },
                    meta,
                },
                { type: FETCH_EVENTS.FAILURE },
            ],
            bailout: () => market && !markets.includes(market),
        },
    };
};



/** WEBPACK FOOTER **
 ** /src/shared/actions/calendar.js
 **/